module.exports = __webpack_public_path__ + "img/030-storm-14.c30a5d19.svg";